import { Box, Button, TextField } from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import { useMediaQuery } from "@mui/material";
import Header from "../../components/Header";
import { useEffect, useState } from "react";
import {
  useGetSponserMutation,
  useUpdateSponserMutation,
} from "../../features/auth/apiSlice";
import { useSelector } from "react-redux";
import { selectSponserID } from "../../features/auth/authSlice";

const phoneRegExp = /^[6-9]\d{9}$/;
const userSchema = yup.object().shape({
  firstName: yup.string().required("required"),
  lastName: yup.string().required("required"),
  email: yup.string().email("invalid email").required("required"),
  contact: yup
    .string()
    .matches(phoneRegExp, "Phone number is not valid")
    .required("required"),
  address1: yup.string().required("required"),
  address2: yup.string().required("required"),
  business_category: yup.string().required("required"),
  business_name: yup.string().required("required"),
});
const Index = () => {
  const isNonMobile = useMediaQuery("(min-width:600px)");

  const sponserId = useSelector(selectSponserID);
  const [sponser] = useGetSponserMutation();
  const [updateSponser] = useUpdateSponserMutation();

  const [initialValues, setInitialValues] = useState({
    firstName: "",
    lastName: "",
    email: "",
    contact: "",
    address1: "",
    address2: "",
    business_category: "",
    business_name: "",
  });

  useEffect(() => {
    const getSponserInfo = async () => {
      const response: any = await sponser(sponserId);
      setInitialValues({
        firstName: response?.data?.sponser?.name?.split(" ")[0],
        lastName: response?.data?.sponser?.name?.split(" ")[1],
        email: response?.data?.sponser?.email,
        contact: response?.data?.sponser?.phoneNumber,
        address1: response?.data?.sponser?.address,
        address2: response?.data?.sponser?.address,
        business_category: response?.data?.sponser?.business_category,
        business_name: response?.data?.sponser?.business_name,
      });
    };
    getSponserInfo();
  }, [sponserId, sponser]);

  const handleFormSubmit = async (values: any) => {
    await updateSponser({
      credentials: values,
      id: sponserId,
    });
  };

  return (
    <Box m="20px" sx={{ marginTop: "100px" }}>
      <Header title="Account Settings" subtitle="Edit or update your profile" />
      <Formik
        onSubmit={handleFormSubmit}
        initialValues={initialValues}
        validationSchema={userSchema}
      >
        {/* @ts-ignore */}
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
        }) => {
          return (
            <form onSubmit={handleSubmit}>
              <Box
                mt={2}
                display={"grid"}
                gap="12px"
                gridTemplateColumns={"repeat(4, minmax(0,1fr))"}
                sx={{
                  "& > div": { gridColumn: isNonMobile ? undefined : "span 4" },
                }}
              >
                <TextField
                  fullWidth
                  variant="outlined"
                  type={"text"}
                  label="First Name"
                  onBlur={handleBlur}
                  onChange={(e) => {
                    handleChange(e);
                    setInitialValues({
                      ...initialValues,
                      firstName: e.target.value,
                    });
                  }}
                  value={initialValues.firstName}
                  name="firstName"
                  error={!!touched.firstName && !!errors.firstName}
                  helperText={touched.firstName && errors.firstName}
                  sx={{ gridColumn: "span 2" }}
                />
                <TextField
                  fullWidth
                  variant="outlined"
                  type={"text"}
                  label="Last Name"
                  onBlur={handleBlur}
                  onChange={(e) => {
                    handleChange(e);
                    setInitialValues({
                      ...initialValues,
                      lastName: e.target.value,
                    });
                  }}
                  value={initialValues.lastName}
                  name="lastName"
                  error={!!touched.lastName && !!errors.lastName}
                  helperText={touched.lastName && errors.lastName}
                  sx={{ gridColumn: "span 2" }}
                />
                <TextField
                  fullWidth
                  variant="outlined"
                  type={"text"}
                  label="E-Mail"
                  onBlur={handleBlur}
                  onChange={(e) => {
                    handleChange(e);
                    setInitialValues({
                      ...initialValues,
                      email: e.target.value,
                    });
                  }}
                  value={initialValues.email}
                  name="email"
                  error={!!touched.email && !!errors.email}
                  helperText={touched.email && errors.email}
                  sx={{ gridColumn: "span 2" }}
                />
                <TextField
                  fullWidth
                  variant="outlined"
                  type={"text"}
                  label="Contact Number"
                  onBlur={handleBlur}
                  onChange={(e) => {
                    handleChange(e);
                    setInitialValues({
                      ...initialValues,
                      contact: e.target.value,
                    });
                  }}
                  value={initialValues.contact}
                  name="contact"
                  error={!!touched.contact && !!errors.contact}
                  helperText={touched.contact && errors.contact}
                  sx={{ gridColumn: "span 2" }}
                />
                <TextField
                  fullWidth
                  variant="outlined"
                  type={"text"}
                  label="Address 1"
                  onBlur={handleBlur}
                  onChange={(e) => {
                    handleChange(e);
                    setInitialValues({
                      ...initialValues,
                      address1: e.target.value,
                    });
                  }}
                  value={initialValues.address1}
                  name="address1"
                  error={!!touched.address1 && !!errors.address1}
                  helperText={touched.address1 && errors.address1}
                  sx={{ gridColumn: "span 4" }}
                />
                <TextField
                  fullWidth
                  variant="outlined"
                  type={"text"}
                  label="Address 2"
                  onBlur={handleBlur}
                  onChange={(e) => {
                    handleChange(e);
                    setInitialValues({
                      ...initialValues,
                      address2: e.target.value,
                    });
                  }}
                  value={initialValues.address2}
                  name="address2"
                  error={!!touched.address2 && !!errors.address2}
                  helperText={touched.address2 && errors.address2}
                  sx={{ gridColumn: "span 4" }}
                />
                <TextField
                  fullWidth
                  variant="outlined"
                  type={"text"}
                  label="Business Name"
                  onBlur={handleBlur}
                  onChange={(e) => {
                    handleChange(e);
                    setInitialValues({
                      ...initialValues,
                      business_name: e.target.value,
                    });
                  }}
                  value={initialValues.business_name}
                  name="business_name"
                  error={!!touched.business_name && !!errors.business_name}
                  helperText={touched.business_name && errors.business_name}
                  sx={{ gridColumn: "span 2" }}
                />
                <TextField
                  fullWidth
                  variant="outlined"
                  type={"text"}
                  label="Business Category"
                  onBlur={handleBlur}
                  onChange={(e) => {
                    handleChange(e);
                    setInitialValues({
                      ...initialValues,
                      business_category: e.target.value,
                    });
                  }}
                  value={initialValues.business_category}
                  name="business_category"
                  error={
                    !!touched.business_category && !!errors.business_category
                  }
                  helperText={
                    touched.business_category && errors.business_category
                  }
                  sx={{ gridColumn: "span 2" }}
                />
              </Box>
              <Box display="flex" justifyContent={"start"} mt="20px">
                <Button type="submit" color="secondary" variant="contained">
                  Update
                </Button>
              </Box>
            </form>
          );
        }}
      </Formik>
    </Box>
  );
};

export default Index;
